import React from "react";
import { CreateOrEditGitTrigger } from "./CreateOrEditGitTrigger";
export function CreateReleaseCreationGitTriggersPage() {
    return <CreateOrEditGitTrigger triggerId={undefined}/>;
}
